export const DISCIPLINES = ["Kicker", "Mario Kart", "Dart", "Billard", "Tischtennis"] as const;

export type Discipline = (typeof DISCIPLINES)[number];
export type GameMode = "mario-kart" | "halligalli";

export type Team = {
  id: number;
  name: string;
  memberA: string;
  memberB: string;
};

export type Match = {
  id: number;
  discipline: Discipline;
  slot: number;
  teamAId: number;
  teamBId: number;
  winnerTeamId: number | null;
  bonusTeamId: number | null;
  completedAt: string | null;
};

export type Standing = {
  teamId: number;
  rank: number;
  played: number;
  wins: number;
  losses: number;
  bonus: number;
  points: number;
  remaining: number;
};

export type TeamStatus = {
  teamId: number;
  currentMatchId: number | null;
  nextMatchId: number | null;
};

export type DisciplineState = {
  discipline: Discipline;
  activeMatchId: number | null;
  nextMatchId: number | null;
};

export type TeamCostume = {
  teamId: number;
  enabled: boolean;
};

export type EventState = {
  startedAt: string | null;
  dashboardMessage: string;
  dashboardMessageVisible: boolean;
  gameMode: GameMode;
};

export type AppState = {
  teams: Team[];
  matches: Match[];
  standings: Standing[];
  statuses: TeamStatus[];
  disciplineStates: DisciplineState[];
  teamCostumes: TeamCostume[];
  event: EventState;
};

export function getTeam(teams: Team[], teamId: number) {
  return teams.find((team) => team.id === teamId);
}

export function matchTeams(match: Match, teams: Team[]) {
  return [getTeam(teams, match.teamAId), getTeam(teams, match.teamBId)] as const;
}
